import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { TrendingUp, X } from "lucide-react";
import { trackEvent } from "../api";
import { useLang } from "../i18n";
import { Button } from "./ui/button";

// Shown when an entitlement limit is hit (402 from the API) — a relevant plan
// upgrade prompt instead of a generic failure. Aggregate events only.
export default function UpgradePrompt({ code, limit, current, onClose }) {
  const { t } = useLang();
  const navigate = useNavigate();

  useEffect(() => {
    trackEvent("upgrade_prompt_view", { ref: code });
  }, [code]);

  const go = (target) => {
    trackEvent("upgrade_prompt_click", { ref: code });
    navigate(target);
  };

  return (
    <div data-testid="upgrade-prompt" className="mt-4 rounded-xl border border-amber-300 bg-amber-50 p-4">
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-start gap-3">
          <TrendingUp size={18} className="mt-0.5 shrink-0 text-amber-600" />
          <div>
            <p className="text-sm font-semibold text-amber-900">
              {t("upgrade.limit.title")}
            </p>
            <p data-testid="upgrade-prompt-text" className="mt-0.5 text-xs text-amber-800">
              {t(`upgrade.${code}`)}
              {limit != null && <> {t("upgrade.limit.count")}: <strong>{current}/{limit}</strong></>}
            </p>
            <div className="mt-2.5 flex flex-wrap gap-2">
              <Button
                data-testid="upgrade-prompt-pro"
                size="sm"
                className="bg-[#DC143C] text-white hover:bg-[#B91C1C]"
                onClick={() => go("/platnosc/plan/pro")}
              >
                {t("upgrade.cta.pro")}
              </Button>
              <Button
                data-testid="upgrade-prompt-pricing"
                size="sm"
                variant="outline"
                onClick={() => go("/cennik")}
              >
                {t("upgrade.cta.pricing")}
              </Button>
            </div>
          </div>
        </div>
        {onClose && (
          <button data-testid="upgrade-prompt-close" onClick={onClose} className="text-amber-500 hover:text-amber-700">
            <X size={15} />
          </button>
        )}
      </div>
    </div>
  );
}
